// ROUTES
export const ROUTE_LIST = 'admin2.provider.list';
export const ROUTE_CREATE = 'admin2.provider.create';
export const ROUTE_UPDATE = 'admin2.provider.update';

// STORAGE KEYS
export const PROVIDER_LIST_STORAGE_KEY = 'admin-provider-list';
export const PROVIDER_LIST_VIEW_KEY = 'tv-admin-provider-list';
export const PROVIDER_LIST_FORM_KEY = 'admin-provider-list-form';

// EXCEL FILE NAME
export const PROVIDER_LIST_EXCEL_FILE_NAME = 'Verity-ProviderList';
